import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';
import './styles/globals.css';

// Inject auth headers into every API fetch call (skip truly external URLs like Cloudinary)
import API_BASE from './config';
const _nativeFetch = window.fetch.bind(window);
window.fetch = function (resource, options = {}) {
  const url = typeof resource === 'string' ? resource : resource?.url ?? '';
  const isApiCall = url.startsWith(window.location.origin) || url.includes('localhost:8080') || url.startsWith(API_BASE);
  if (url.startsWith('http') && !isApiCall) {
    return _nativeFetch(resource, options);
  }
  const headers = new Headers(options.headers || {});

  try {
    const user = JSON.parse(sessionStorage.getItem('user') || localStorage.getItem('user') || 'null');
    if (user && user.role && !headers.has('X-User-Role')) headers.set('X-User-Role', user.role);
    if (user && user.username && !headers.has('X-Username')) headers.set('X-Username', user.username);
    if (user && user.employeeCode && !headers.has('X-Employee-Code')) headers.set('X-Employee-Code', user.employeeCode);
    if (user && user.linkedEntityId != null && !headers.has('X-Linked-Entity-Id')) headers.set('X-Linked-Entity-Id', String(user.linkedEntityId));
    if (user && user.linkedEntityType && !headers.has('X-Linked-Entity-Type')) headers.set('X-Linked-Entity-Type', user.linkedEntityType);
    // Multi-tenant — branch users always carry one school; chain admins
    // (SuperAdmin / SuperDev) carry whichever school they've picked in
    // the Topbar selector. The backend's SchoolFilterInterceptor reads
    // this and (a) populates a ThreadLocal so JPA @PrePersist callbacks
    // can stamp new rows with the right school_id, and (b) enables the
    // Hibernate session filter that appends `school_id = ?` to every
    // read query across the 55 per-tenant entities. Missing header
    // means no tenant scoping is applied — used for login + public
    // endpoints that intentionally span schools.
    if (user && user.school && user.school.id != null && !headers.has('X-School-Id')) {
      headers.set('X-School-Id', String(user.school.id));
    }
  } catch (e) { /* ignore */ }

  return _nativeFetch(resource, { ...options, headers });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
